import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	background: #f8f8f8;
	border-radius: 8px;
	padding: 12px 24px;
	width: 100%;
	justify-content: space-between;
`;

export const Section = styled.div`
	flex: 1;
	text-align: center;
	font-size: 15px;
	font-weight: 500;
	color: #222;
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	background: #e5e5e5;
	margin: 0 16px;
`;
